import { lazy } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { Layout } from '../components/layout';

const Invoices = lazy(() => import('../pages/invoices'));
const NotFound = lazy(() => import('../pages/notFound'));

export function Router() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      errorElement: <NotFound />,
      children: [
        {
          path: '/invoices',
          element: <Invoices />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}
